// extracted by mini-css-extract-plugin
export default {"link-button":"SquareLinkButton_link-button__2OK6H"};